import 'flickity/dist/flickity.min.css'

import { GetStaticPropsContext, NextPage } from 'next'
import { Layout, withLayoutProps } from 'slices/Layout'

import { BaseSeo } from '@/components/seo/BaseSeo'
import { BookProductPage } from '@/slices/Shop/BookProductPage'

export const getStaticProps = async (context: GetStaticPropsContext) =>
  withLayoutProps(context, {
    props: {},
  })

const SoftcoverBookPage: NextPage = ({ ...layoutProps }) => (
  <Layout {...layoutProps}>
    <BaseSeo
      title="Softcover Storybook - Pixie World"
      description="Print any personalised storybook as an affordable softcover book, delivered to your door."
    />
    <BookProductPage
      coverType="softcover"
      title="Softcover Storybook"
      images={[
        '/images/products/softcover_sample.png',
        '/images/products/softcover_no_background_sample.png',
      ]}
      description="Print any personalised book as an affordable softcover"
      features={[
        'Affordable softcover format',
        'Print any personalised story',
        'Delivered to your door',
      ]}
    />
  </Layout>
)

export default SoftcoverBookPage
